<template>
  <div>
    搬家
  </div>
</template>

<script>
  export default {
    name: 'movehouse',
    data(){
      return {

      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../styles/mixin.less';
  
</style>